import { FC } from "react";
import {
  AccordionHeader,
  AccordionHeaderText,
  FormController,
  MuiButtonPrimary,
  MuiGrid,
  MuiSelect,
  OptionsDataType,
  SearchSaveFiltersSubHeader,
  MuiBox,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";

import { useFormContext } from "react-hook-form";
import { useGridContainer } from "../../../../hooks/useGridContainer";
import { useNavigationSiteCore } from "../../../../hooks/useNavigationSiteCore";
import { SystemMessageSearchFormKey } from "../../modelsAndSchemas/models";
import { searchSystemMessageSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { SystemMessageSearchFormWrapper } from "./SystemMessageSearchForm.style";
import { useSyncFormValidity } from "../../../../hooks/useSyncFormValidity/useSyncFormValidity";
import { useMediaQueries } from "../../../../hooks/useMediaQueries";

interface SystemMessageSearchFormProps {
  pageId: string;
  handleClearAllSearch: () => void;
  handleSearchClick: () => void;
  countryListOptions: OptionsDataType[];
}

export const SystemMessageSearchForm: FC<SystemMessageSearchFormProps> = ({
  pageId,
  handleClearAllSearch,
  handleSearchClick,
  countryListOptions,
}) => {
  const { isMobile } = useMediaQueries();
  const { commonLabels } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();

  const { gridSizeMedium: gridSize, gridSizeMediumClass } = useGridContainer();

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { fetchLabel, fetchComponentTitle } = useSiteCore();

  const getFormLabel = (key: string) =>
    fetchLabel(searchSystemMessageSiteCoreKeys.searchMessagesKey, key);

  const mandatoryFields = [SystemMessageSearchFormKey.country];

  useSyncFormValidity({
    formKey: "searchSystemMessageForm",
    mandatoryFields,
    errors,
    isMobile,
  });

  const renderSystemSearchHeader = () => {
    return (
      <SearchSaveFiltersSubHeader onResetAllClick={handleClearAllSearch} />
    );
  };

  return (
    <SystemMessageSearchFormWrapper>
      <AccordionHeader
        title={
          <AccordionHeaderText
            label={fetchComponentTitle(
              searchSystemMessageSiteCoreKeys.searchMessagesKey,
            )}
          />
        }
        formKey="searchSystemMessageForm"
      >
        <MuiBox className="header-accordion">
          {renderSystemSearchHeader()}
        </MuiBox>
        <form data-testid="system-search-form">
          <MuiGrid container className="form-container">
            <MuiGrid size={gridSize} className={gridSizeMediumClass}>
              <FormController
                control={control}
                name={SystemMessageSearchFormKey.country}
              >
                <MuiSelect
                  label={getFormLabel(searchSystemMessageSiteCoreKeys.country)}
                  options={countryListOptions}
                  value=""
                  id={`${pageId}-${SystemMessageSearchFormKey.country}`}
                  placeholder={commonLabels.selectPlaceHolder}
                  visibleDefaultSelectOption
                  requiredARIALabel={commonARIALabel.required}
                  isMandatory
                  showSearch
                  searchPlaceholder={commonLabels.search}
                />
              </FormController>
            </MuiGrid>
            <MuiGrid
              className={`${gridSizeMediumClass} search-button-container`}
            >
              <MuiButtonPrimary
                onClick={handleSearchClick}
                id={`${pageId}-search`}
                className="search-button"
              >
                {commonLabels.search}
              </MuiButtonPrimary>
            </MuiGrid>
          </MuiGrid>
        </form>
      </AccordionHeader>
    </SystemMessageSearchFormWrapper>
  );
};
